'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$53() {
  this.bjV = null;
  this.bjW = false;
}
export { $c_Lpresto_PrestoRouter$$anon$53 as $c_Lpresto_PrestoRouter$$anon$53 };
$p = $c_Lpresto_PrestoRouter$$anon$53.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$53;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$53() {
}
export { $h_Lpresto_PrestoRouter$$anon$53 as $h_Lpresto_PrestoRouter$$anon$53 };
$h_Lpresto_PrestoRouter$$anon$53.prototype = $p;
$p.bW = (function() {
  if ((!this.bjW)) {
    this.bjV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bjW = true;
  }
  return this.bjV;
});
$p.P = (function() {
  return this.bW();
});
var $d_Lpresto_PrestoRouter$$anon$53 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$53, "presto.PrestoRouter$$anon$53", ({
  Ok: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$53 as $d_Lpresto_PrestoRouter$$anon$53 };
//# sourceMappingURL=presto.-Presto-Router$$anon$53.js.map
